import {
    EditorTabValue,
    SourceDocumentType,
    StaticEditorTabValue,
    TherapySessionType,
} from '../../types';
import { SessionTypeToMedicalNoteTypeMap } from '../types-utils';
import { ProductAnalyticsSummaryType } from './analytics-types';

export const getSchema = (
    entity: string,
    version: `${number}-${number}-${number}` = '1-0-0',
) => {
    return `iglu:io.upheal/${entity}/jsonschema/${version}`;
};

export const editorToAnalyticsSummaryType = (
    editor: EditorTabValue,
    sessionType: TherapySessionType,
) => {
    switch (editor) {
        case StaticEditorTabValue.PRIVATE:
            return 'therapy';
        case StaticEditorTabValue.MEDICAL: {
            return SessionTypeToMedicalNoteTypeMap[sessionType];
        }
        case StaticEditorTabValue.CLIENT_NOTE:
            return 'clientSummary';
        case StaticEditorTabValue.ADD_NEW:
            return 'addNew';
        default:
            return 'custom';
    }
};

export const chapterSourceTypeToAnalyticsSummaryType = (
    sourceType:
        | SourceDocumentType.CHAPTER_GIST
        | SourceDocumentType.CHAPTER_HEADLINE
        | SourceDocumentType.CHAPTER_SNIPPET,
) => {
    switch (sourceType) {
        case SourceDocumentType.CHAPTER_GIST:
            return ProductAnalyticsSummaryType.ChapterGist;
        case SourceDocumentType.CHAPTER_HEADLINE:
            return ProductAnalyticsSummaryType.ChapterHeadline;
        case SourceDocumentType.CHAPTER_SNIPPET:
            return ProductAnalyticsSummaryType.ChapterSnippet;
    }
};
